import React from 'react'
import { AuthContext } from '../Contexts/AuthContext'

export default function useIsAuthenticated(): string {
  const authContext = React.useContext(AuthContext)

  return authContext?.user?.uid as string
}
